import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";

 
 
 
export default function RestricaoAvancadaScore({
  restricaoAvancadaScore
}: {
  restricaoAvancadaScore: any
}) {
  const { t } = useTranslation();

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };

  const getResumoRefin = () => {
    const resumos: any[] = [];
    if(restricaoAvancadaScore.dados && restricaoAvancadaScore.dados.refin && restricaoAvancadaScore.dados.refin.registro && restricaoAvancadaScore.dados.refin.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Registros',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-calendar-clock',
        label: 'Última ocorrência',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      let data:Date|null = null
      restricaoAvancadaScore.dados.refin.registro.forEach((ocorrencia:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(ocorrencia.valor.replaceAll('.', '').replace(',', '.'))
        const [mes, ano, ] = ocorrencia.data_entrada.split(/[\/: ]/).map((v: string) => parseInt(v));
        const dataFormatada = new Date(ano, mes - 1);
        if(data == null || data < dataFormatada){
          data = dataFormatada
        }
        
      });
      resumos[1].value = (data ? formatDate(data) : '');
      resumos[0].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    return resumos;
  }

  const getResumo = () => {
    const resumos: any[] = [];
    if(restricaoAvancadaScore.dados && restricaoAvancadaScore.dados.pefin && restricaoAvancadaScore.dados.pefin.registro && restricaoAvancadaScore.dados.pefin.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Registros',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-calendar-clock',
        label: 'Última ocorrência',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      let data:Date|null = null
      restricaoAvancadaScore.dados.pefin.registro.forEach((ocorrencia:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(ocorrencia.valor.replaceAll('.', '').replace(',', '.'))
        const [mes, ano, ] = ocorrencia.data_entrada.split(/[\/: ]/).map((v: string) => parseInt(v));
        const dataFormatada = new Date(ano, mes - 1);
        if(data == null || data < dataFormatada){
          data = dataFormatada
        }
        
      });
      resumos[1].value = (data ? formatDate(data) : '');
      resumos[0].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    return resumos;
  }
 
  const getResumoProtesto = () => {
    const resumos: any[] = [];
    if(restricaoAvancadaScore.dados.protesto && restricaoAvancadaScore.dados.protesto.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      const comarcas: any[] = []
      restricaoAvancadaScore.dados.protesto.registro.forEach((prot:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(prot.valor.replace('.', '').replace(',', '.'))
        if(!comarcas.includes(prot.origem)){
          comarcas.push(prot.origem)
        }
      });
      resumos[0].value = comarcas.length;
      resumos[1].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    
    return resumos;
  }
 
  const naturezaTemplate = (item:any) => {
    return item.comprador ? 'Comprador' : 'Avalista';
  }

  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoAvancadaScore.dados.protesto.registro && restricaoAvancadaScore.dados.protesto.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span>) }</div>;
  }

  const headerTemplateRefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoAvancadaScore.dados.refin.registro && restricaoAvancadaScore.dados.refin.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('refins')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('refins')}</span>) }</div>;
  }

  const headerTemplatePefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoAvancadaScore.dados.pefin.registro && restricaoAvancadaScore.dados.pefin.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span>) }</div>;
  }

 
  
  return (
    <div>
    {restricaoAvancadaScore.mensagemErro ? (<p>{restricaoAvancadaScore.mensagemErro}</p>) :
    (
    <div>
      
    
    <Panel headerTemplate={headerTemplateProtesto}>
        {restricaoAvancadaScore.dados.protesto.registro.length === 0 ? ( <NadaConsta />) : (<>
          <div className="flex-consulta  flex-wrap gap-3">
                {getResumoProtesto().map((item:any, index:number) => (
                                 
                    <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                        <div className="flex-consulta  justify-content-between gap-5">
                            <div className="flex-consulta  flex-column gap-1">
                                <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                                <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                                <i className={item.icon} />
                            </span>
                        </div>
                    </Card>
                  
                  ))}
              </div>
        <DataTable size="small" value={restricaoAvancadaScore.dados.protesto.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_ocorrencia" header={t('data')}></Column>
            <Column field="cartorio" header={t('cartorio')}></Column>
            <Column field="cidade" header={t('cidade')}></Column>
            <Column field="uf" header={t('uf')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplateRefin}>
        {restricaoAvancadaScore.dados.refin.registro.length === 0 ? ( <NadaConsta />) : (<>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumoRefin().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={restricaoAvancadaScore.dados.refin.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_ocorrencia" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column body = {naturezaTemplate} header={t('natureza')}></Column>
            <Column field="origem" header={t('informante')}></Column>
            <Column field="cidade" header={t('cidade')}></Column>
            <Column field="uf" header={t('uf')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplatePefin}>
        {restricaoAvancadaScore.dados.pefin.registro.length === 0 ? ( <NadaConsta />) : (<>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumo().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={restricaoAvancadaScore.dados.pefin.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_ocorrencia" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column body = {naturezaTemplate} header={t('natureza')}></Column>
            <Column field="origem" header={t('informante')}></Column>
            <Column field="cidade" header={t('cidade')}></Column>
            <Column field="uf" header={t('uf')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>

    </div>)}
  </div>
  )
}